"use client"

import "@/styles/index.css"

import {
  HydrationBoundary,
  QueryClient,
  QueryClientProvider,
  type DehydratedState
} from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { useMemo } from "react"
import { Toaster } from "sonner"
import { AuthProvider } from "@/contexts/SupabaseAuthContext"
import { SubscriptionProvider } from "@/contexts/SubscriptionContext"
import { ProjectProvider } from "@/contexts/ProjectContext"

export function Providers({
  children,
  dehydratedState
}: {
  children: React.ReactNode
  dehydratedState?: DehydratedState
}) {
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { refetchOnWindowFocus: false },
          mutations: { networkMode: "online" }
        }
      }),
    []
  )
  return (
    <QueryClientProvider client={queryClient}>
      <HydrationBoundary state={dehydratedState}>
        <AuthProvider>
          <SubscriptionProvider>
            <ProjectProvider>
              <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                  style: {
                    background: "rgb(17 24 39)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    color: "rgb(229 231 235)",
                    fontSize: "13px",
                  },
                }}
                offset={16}
              />
              <ReactQueryDevtools initialIsOpen={false} />
              {children}
            </ProjectProvider>
          </SubscriptionProvider>
        </AuthProvider>
      </HydrationBoundary>
    </QueryClientProvider>
  )
}
